module.exports = __webpack_public_path__ + "static/media/web_dev_small-min.63d8198c.png";